export default __webpack_public_path__ + "static/media/why_choose_us_new.421dd163.svg";